/** @jsx jsx */
import { jsx } from '@emotion/react';
import type { ReactNode } from 'react';

import { Animation, Typography } from '@zapier/design-system';
import { labelStyles } from '@zapier/style-encapsulation';

type Props = {
  /**
   * The error message to render.
   */
  children: ReactNode;
};

const Styles = labelStyles('InAppSidebarError', {
  toggle: {
    font: `var(--zds-small-print-1, 400 13px/20px ${Typography.base.fontFamily})`,
    color: 'var(--zds-status-error, #F65258)',
    cursor: 'pointer',
    padding: '3px 0',
    borderBottom: `1px solid transparent`,
    transition: Animation.transitionValue,
    '&:hover, &:focus': {
      borderBottomColor: 'var(--zds-status-error, #F65258)',
    },
  },
  message: {
    color: 'var(--zds-status-error, #F65258)',
    marginTop: 10,
    padding: 10,
    border: `1px solid var(--zds-background-strongest, #ECE9DF)`,
    borderRadius: 5,
    font: '14px/18px monospace',
  },
});

/**
 * Simple error message to render if, for instance, data
 * fails to load. Should ideally never be seen by users.
 */
const InAppSidebarError = (props: Props) => {
  return (
    <details data-zds>
      <summary css={Styles.toggle} data-zds>
        Oh no, something went wrong!
      </summary>
      <pre css={Styles.message} data-zds>
        {props.children}
      </pre>
    </details>
  );
};

export default InAppSidebarError;
